import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// A field label that shows its help text when hovered.
const FieldLabel = ({ id, text, tip, as: Tag = "label", className = "" }) => (
  <OverlayTrigger placement="top" delay={{ show: 300, hide: 0 }} overlay={<Tooltip id={"tip-" + id} className="field-help-tooltip">{tip}</Tooltip>}>
    <Tag className={("field-label-tip " + className).trim()}>
      {text}
      <FontAwesomeIcon icon="info-circle" className="field-label-tip-icon" />
    </Tag>
  </OverlayTrigger>
);

export default FieldLabel;
